import * as Api from '@ViewModels';

type BehaviorCaseLike = Api.IAutomationStepCaseStatement & {
	_type?: string;
	caseType?: string;
	engagementType?: string | number;
	isDefault?: boolean;
};

type NormalizedEngagementType = 'reply' | 'open' | 'anylinkclick' | 'specificlinkclick' | undefined;

function normalizeEngagementType(engagementType: string | number | undefined): NormalizedEngagementType {
	if (typeof engagementType === 'number') {
		return undefined;
	}

	if (typeof engagementType !== 'string') {
		return undefined;
	}

	switch (engagementType.toLowerCase()) {
		case 'reply':
			return 'reply';
		case 'open':
			return 'open';
		case 'anylinkclick':
			return 'anylinkclick';
		case 'specificlinkclick':
			return 'specificlinkclick';
		default:
			return undefined;
	}
}

/**
 * Gets the display label for a behavior case.
 */
export function getBehaviorCaseLabel(behaviorCase: BehaviorCaseLike): string {
	if (behaviorCase.name) return behaviorCase.name;

	const caseType = behaviorCase._type || behaviorCase.caseType;

	if (!caseType && behaviorCase.isDefault) {
		return 'If no engagement (timeout)';
	}

	switch (caseType) {
		case 'EmailEngagementCaseStatement': {
			const engType = normalizeEngagementType(behaviorCase.engagementType);
			switch (engType) {
				case 'reply':
					return 'If recipient replies';
				case 'open':
					return 'If recipient opens';
				case 'anylinkclick':
					return 'If recipient clicks any links';
				case 'specificlinkclick':
					return 'If recipient clicks specific link';
				default:
					return 'Email engagement';
			}
		}
		case 'TextEngagementCaseStatement':
			return 'If recipient replies to text';
		case 'EventRegistrationResponseCaseStatement':
			return 'Event registration response';
		case 'TimeoutCaseStatement':
			return 'If no engagement (timeout)';
		default:
			return behaviorCase.name || 'Behavior case';
	}
}
